import React, { useState } from 'react';
// material
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Divider, Container, Hidden } from '@material-ui/core';

import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';

const logo = process.env.PUBLIC_URL + "/galilaio/logo_white.png";

interface FooterSmallProps {
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  onClick(action: string, rounte: string): void;
}

const FooterSmall: React.FC<FooterSmallProps> = (props) => {

  const classes = useStyles({});

  const maxWidth = props.maxWidth || false;

  return (
    <div className={classes.container}>
      <Container maxWidth={maxWidth} style={{maxWidth:1100}}>
        <Grid container className={classes.containerGrid}>
          <Grid item xs={4} md={4} sm={4} className={classes.logoContainer}>
            <img
              src={logo}
              className={classes.logo}
              onClick={() => props.onClick('route', '/')}
            />
          </Grid>
          <Grid item xs={8} md={4} sm={5}>
            <div className={classes.links}>
                <div className={classes.link} onClick={() => props.onClick('route', '/terms')}>Terms Of Service</div>
                <div className={classes.link} onClick={() => props.onClick('route', '/privacy-policy')}>Privacy Policy</div>
            </div>
            <Hidden smUp>
              <div className={classes.socialIcons}>
                <div>
                  <FacebookIcon className={classes.icon} onClick={() => props.onClick('route-external', 'https://www.facebook.com/itsgalilaio')}  />
                  <InstagramIcon className={classes.icon} onClick={() => props.onClick('route-external', 'https://www.instagram.com/galilaio_sf')} />
                </div>
                <div className={classes.footer}>© 2023 v. 1.5.5</div>
              </div>
            </Hidden>
          </Grid>
          <Hidden xsDown>
            <Grid item xs={12} md={4} sm={3}>
              <div className={classes.socialIcons}>
                <div>
                  <FacebookIcon className={classes.icon} onClick={() => props.onClick('route-external', 'https://www.facebook.com/itsgalilaio')}  />
                  <InstagramIcon className={classes.icon} onClick={() => props.onClick('route-external', 'https://www.instagram.com/galilaio_sf')} />
                </div>
                <div className={classes.footer}>© 2023 v. 1.5.5</div>
              </div>
            </Grid>
          </Hidden>
          
        </Grid>
      </Container>
    </div>

  )
};
export default FooterSmall;

const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: '#2f3f52',
    padding: 10,
    width: '100%',
  },
  containerGrid: {
    backgroundColor: '#2f3f52',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-between',
    }
  },
  header: {
    color: '#FFF',
    fontSize: 24,
    textAlign: 'center'
  },
  headerLink: {
    color: '#00ABCA',
    cursor: 'pointer'
  },
  logoContainer: {
    [theme.breakpoints.down('sm')]: {
      display:'flex',
      justifyContent: 'center',
    },
  },
  logo: {
    width: 150,
    cursor: "pointer",
    [theme.breakpoints.down('xs')]: {
      width: "80%",
      marginBottom: 5
    }
  },
  footer: {
    paddingTop: 7,
    paddingLeft: 10,
    textAlign: 'center',
    fontSize: 14,
    color: '#627995',
    [theme.breakpoints.down('sm')]: {
      fontSize: 10,
    }
  },
  links: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 16,
    [theme.breakpoints.down('xs')]: {
      fontSize: 12,
      justifyContent: 'flex-end',
    }
  },
  link: {
    cursor: 'pointer',
    color: '#00ABCA',
    paddingLeft: 10,
    paddingRight: 10,
    [theme.breakpoints.down('xs')]: {
      padding: "5px 5px 0 5px"
    }
  },
  socialIcons: {
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      display:'flex',
      marginTop: 5,
      marginRight: 5
    },
  },
  icon: {
    color: '#00ABCA',
    fontSize: 34,
    paddingLeft: 5,
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      fontSize: 26
    }
  },
  divider: {
    color: '#4A5766'
  }
}));


// WEBPACK FOOTER //
// ./src/components/footer/FooterSmall.tsx